module.exports = __webpack_public_path__ + "static/img/2003.3b3ed78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2003.jpg
// module id = 294
// module chunks = 0